var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c(
          "div",
          { staticClass: "grid grid-cols-2 gap-3" },
          [
            _c("ValidationProvider", {
              attrs: { name: "First Name", rules: "required_field" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mainTtile" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" First Name "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "firstname",
                              placeholder: "Enter first name",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) => _vm.updateField("firstname", val),
                            },
                            model: {
                              value: _vm.localFormData.firstname,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "firstname", $$v)
                              },
                              expression: "localFormData.firstname",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { name: "Last Name", rules: "required_field" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mainTtile" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Last Name "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "lastname",
                              placeholder: "Enter last name",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) => _vm.updateField("lastname", val),
                            },
                            model: {
                              value: _vm.localFormData.lastname,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "lastname", $$v)
                              },
                              expression: "localFormData.lastname",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { name: "Preferred Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mainTtile" }, [
                                      _vm._v("Preferred Name"),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "preferred_name",
                              placeholder: "Enter preferred name",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) =>
                                _vm.updateField("preferred_name", val),
                            },
                            model: {
                              value: _vm.localFormData.preferred_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localFormData,
                                  "preferred_name",
                                  $$v
                                )
                              },
                              expression: "localFormData.preferred_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { rules: "required_field", name: "Client ID" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mainTtile" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Client ID "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "client_id",
                              placeholder: "Enter client ID",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) => _vm.updateField("client_id", val),
                            },
                            model: {
                              value: _vm.localFormData.client_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "client_id", $$v)
                              },
                              expression: "localFormData.client_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { name: "Date of Birth", vid: "dob" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        { attrs: { title: "Date of Birth", errors: errors } },
                        [
                          _c("FormDatepicker", {
                            attrs: {
                              name: "dob",
                              id: "dateOfBirth",
                              heightClass: "datePickerHeight",
                              placeholder: "Select date of birth",
                              isCalenderIcon: true,
                              inputClass: "w-full",
                            },
                            on: { input: (val) => _vm.updateField("dob", val) },
                            model: {
                              value: _vm.localFormData.dob,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "dob", $$v)
                              },
                              expression: "localFormData.dob",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { name: "Gender" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        { attrs: { title: "Gender", errors: errors } },
                        [
                          _c("FormSelect", {
                            attrs: {
                              name: "gender",
                              placeholder: "Select gender",
                              options: [
                                { label: "Male", value: "male" },
                                { label: "Female", value: "female" },
                                { label: "Other", value: "other" },
                              ],
                              getParentCustom: "clientWidth",
                            },
                            on: {
                              input: (val) => _vm.updateField("gender", val),
                            },
                            model: {
                              value: _vm.localFormData.gender,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "gender", $$v)
                              },
                              expression: "localFormData.gender",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "div",
              { staticClass: "col-span-2" },
              [
                _c("LocationModal", {
                  attrs: {
                    location: _vm.localFormData.address,
                    isClient: true,
                  },
                  on: {
                    locationAdded: (val) =>
                      _vm.updateField("address", val.description),
                  },
                }),
              ],
              1
            ),
            _c("ValidationProvider", {
              attrs: { rules: "required_field|phone", name: "Phone Number" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mainTtile" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Phone Number "),
                                      _c("span", { staticClass: "subText" }, [
                                        _vm._v("(Administrative use only) "),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("StandardizedPhoneInput", {
                            attrs: {
                              invalid: !!errors.length,
                              "error-message": errors[0],
                              placeholder: "(123) 456-7890",
                              size: "md",
                              variant: "outline",
                              "custom-class": "w-full",
                            },
                            on: {
                              input: (val) =>
                                _vm.updateField("phone_number", val),
                              validation: _vm.handlePhoneValidation,
                            },
                            model: {
                              value: _vm.localFormData.phone_number,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "phone_number", $$v)
                              },
                              expression: "localFormData.phone_number",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { rules: "required_field", name: "Email Address" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mainTtile" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Email Address"),
                                      _c("span", { staticClass: "subText" }, [
                                        _vm._v("(Administrative use only)"),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "email_address",
                              placeholder: "Enter email address",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) =>
                                _vm.updateField("email_address", val),
                            },
                            model: {
                              value: _vm.localFormData.email_address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localFormData,
                                  "email_address",
                                  $$v
                                )
                              },
                              expression: "localFormData.email_address",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "div",
              { staticClass: "col-span-2" },
              [
                _c(
                  "ValidationProvider",
                  { attrs: { name: "Tags" } },
                  [
                    _c(
                      "FormGroup",
                      {
                        attrs: { name: "tags" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mainTtile" }, [
                                  _c("span", { staticClass: "required-icon" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v("Smart Tags"),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v(
                                      "(will be used as required skills to match a resource to a client)"
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("CustomSkillsMultiselect", {
                          attrs: {
                            previouslyChosenSkillsIds: _vm.projectSkillsIds,
                            disabled: false,
                            customSkillLabel: "Enter keyword to search tag",
                            getParentContainer: "customWidthInput",
                            max: 25,
                          },
                          on: { skillsListUpdated: _vm.updateSkills },
                        }),
                      ],
                      1
                    ),
                    _vm.hasSkill
                      ? _c("p", { staticClass: "text-sm text-red-600" }, [
                          _vm._v(" " + _vm._s(_vm.tagsError) + " "),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-span-2" },
              [
                _c(
                  "ValidationProvider",
                  { attrs: { name: "Soft Skills" } },
                  [
                    _c(
                      "FormGroup",
                      {
                        attrs: { name: "soft_skills" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mainTtile" }, [
                                  _vm._v(" Soft Skills"),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v(
                                      "Preferred Soft Skills of assigned Resource (optional)"
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("CustomSoftSkillsMultiselect", {
                          attrs: {
                            previouslyChosenSoftSkillsIds:
                              _vm.projectSoftSkillsIds,
                            disabled: false,
                            customSoftSkillLabel:
                              "Enter keyword to search soft skill",
                            getParentContainer: "customWidthInput",
                            max: 25,
                          },
                          on: { softSkillsListUpdated: _vm.updateSoftSkills },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-span-2" },
              [
                _c("ValidationProvider", {
                  attrs: { name: "Manager" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ errors, failed }) {
                        return [
                          _c(
                            "FormGroup",
                            {
                              staticClass: "w-full",
                              attrs: {
                                errors: errors,
                                title: "",
                                name: "manager",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("p", { staticClass: "mainTtile" }, [
                                          _vm._v("Manager"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("ManagersMultiselect", {
                                attrs: {
                                  value: _vm.localFormData.manager_id,
                                  invalid: failed,
                                  multiple: false,
                                  getParentcontainerStyle: "customWidthInput",
                                  placeholder: "Select a manager",
                                  title: "Manager",
                                },
                                on: { input: _vm.handleManagerInput },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._m(0),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mainTtile" }, [
                          _vm._v(" Access Type "),
                          _c("span", { staticClass: "subText" }, [
                            _vm._v("(Administrative use only) "),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("FormSelect", {
                  attrs: {
                    name: "access_type",
                    placeholder: "Select access type",
                    options: [
                      { label: "Personal Care", value: "Personal Care" },
                      { label: "Home Care", value: "Home Care" },
                      { label: "Respite Care", value: "Respite Care" },
                      { label: "Other", value: "Other" },
                    ],
                    getParentCustom: "clientWidth",
                  },
                  on: { input: (val) => _vm.updateField("access_type", val) },
                  model: {
                    value: _vm.localFormData.access_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.localFormData, "access_type", $$v)
                    },
                    expression: "localFormData.access_type",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { attrs: { title: "Access Number" } },
              [
                _c("FormInputGroup", {
                  attrs: {
                    name: "access_number",
                    placeholder: "Enter access number",
                    inputClass: "w-full",
                  },
                  on: { input: (val) => _vm.updateField("access_number", val) },
                  model: {
                    value: _vm.localFormData.access_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.localFormData, "access_number", $$v)
                    },
                    expression: "localFormData.access_number",
                  },
                }),
              ],
              1
            ),
            _vm.localFormData.access_type === "Other"
              ? _c(
                  "div",
                  { staticClass: "col-span-2" },
                  [
                    _c(
                      "FormGroup",
                      { attrs: { title: "Other" } },
                      [
                        _c("FormInputGroup", {
                          attrs: {
                            name: "access_type_other",
                            placeholder: "Enter",
                            inputClass: "w-full",
                          },
                          on: {
                            input: (val) =>
                              _vm.updateField("access_type_other", val),
                          },
                          model: {
                            value: _vm.localFormData.access_type_other,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localFormData,
                                "access_type_other",
                                $$v
                              )
                            },
                            expression: "localFormData.access_type_other",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-span-2" },
              [
                _c(
                  "FormGroup",
                  { attrs: { title: "Special Instructions" } },
                  [
                    _c("FormTextarea", {
                      attrs: {
                        customBorderClass: "borderTen",
                        name: "special_instructions",
                        placeholder: "Enter access number",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("special_instructions", val),
                      },
                      model: {
                        value: _vm.localFormData.special_instructions,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localFormData,
                            "special_instructions",
                            $$v
                          )
                        },
                        expression: "localFormData.special_instructions",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "col-span-2 space-y-4 mt-4" }, [
              _c("div", { staticClass: "bg-blue-50 p-6 rounded-lg" }, [
                _c("div", [
                  _c("h4", { staticClass: "text-base font-medium" }, [
                    _vm._v(" Email notification settings "),
                  ]),
                  _c(
                    "p",
                    { staticClass: "text-sm font-regular text-gray-600 mt-1" },
                    [
                      _vm._v(
                        " Please select who you would like to receive email notifications. This setting can be updated later. "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-4 flex gap-3 items-center" },
                    [
                      _c(
                        "ValidationProvider",
                        { attrs: { name: "Notify Admin" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center" },
                            [
                              _c("FormCheckbox", {
                                attrs: {
                                  name: "notify_admin_by_email",
                                  label: "Admin",
                                },
                                on: {
                                  input: (val) =>
                                    _vm.updateField(
                                      "notify_admin_by_email",
                                      val
                                    ),
                                },
                                model: {
                                  value:
                                    _vm.localFormData.notify_admin_by_email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localFormData,
                                      "notify_admin_by_email",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "localFormData.notify_admin_by_email",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "ValidationProvider",
                        { attrs: { name: "Notify Manager" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center" },
                            [
                              _c("FormCheckbox", {
                                attrs: {
                                  name: "notify_manager_by_email",
                                  label: "Manager",
                                },
                                on: {
                                  input: (val) =>
                                    _vm.updateField(
                                      "notify_manager_by_email",
                                      val
                                    ),
                                },
                                model: {
                                  value:
                                    _vm.localFormData.notify_manager_by_email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.localFormData,
                                      "notify_manager_by_email",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "localFormData.notify_manager_by_email",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "flex justify-end mt-4" }, [
      _c(
        "div",
        { staticClass: "flex space-x-4" },
        [
          _vm.isDrafted === "null" || _vm.isDrafted === true
            ? [
                _c("UIButton", {
                  attrs: {
                    variant: "outline",
                    disabled: _vm.invalid || _vm.hasSkill,
                    size: "sm",
                    buttonText: "Save as draft",
                  },
                  on: { click: _vm.saveDraft },
                }),
                _c("UIButton", {
                  attrs: {
                    variant: "primary",
                    disabled: _vm.invalid || _vm.hasSkill,
                    size: "sm",
                    buttonText: "Create",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("submit")
                    },
                  },
                }),
              ]
            : _vm.isDrafted === false
            ? [
                _c("UIButton", {
                  attrs: {
                    variant: "primary",
                    disabled: _vm.invalid || _vm.hasSkill,
                    size: "sm",
                    buttonText: "Update",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("submit")
                    },
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-lg font-medium" }, [
        _vm._v("Access Information"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }